export const getCompleteUrl = (path: string) => {
  const protocol = window.location.protocol;
  const host = window.location.host;
  const domainUrl = protocol.concat("//").concat(host);
  return domainUrl + '/' + path
}